// cssAttrSafe — make a composed CSS declaration string safe to embed inside a
// DOUBLE-QUOTED HTML attribute (e.g. `style="..."`) that is injected via
// dangerouslySetInnerHTML.
//
// Why this exists (regression, validator 2026-07-15): the animated-loop picker
// (proceduralLibrary/loops/LoopPanel) builds each preview as
//   `<span style="...${cssFragment}"></span>`
// via dangerouslySetInnerHTML. When cssFragment contains a background image the
// fragment looks like `background:url("data:image/svg+xml,...")`. The inner
// DOUBLE quote after `url(` CLOSES the style attribute early, so 16/20 loop
// previews rendered BLANK (computed backgroundImage=url(""), animation dropped);
// only the 4 gradient loops (no url()) survived.
//
// The fix: a double quote is the ONLY character that can break a double-quoted
// attribute value, so we swap every `"` for `'`. `url('data:...')` and
// `content:'...'` are valid CSS, so the rendered result is unchanged — the quote
// style is purely syntactic. (This also keeps every url() QUOTED, satisfying the
// G-51 gate: never emit an unquoted url() with data:/spaces.)
//
// Use this at EVERY point that injects a composed CSS string into a double-quoted
// HTML attribute string. Values applied through React's `style={{...}}` prop or
// an element's `.style` do NOT need it (React/CSSOM handle escaping) — this is
// only for raw innerHTML attribute strings.
export default function cssAttrSafe(css) {
  if (typeof css !== "string") return css;
  return css.replace(/"/g, "'");
}
